<script>
	import { access_token, push_button_message } from '../../stores';
  import { querystring } from 'svelte-spa-router';
  import { is_show_copy_comment_tooltip, is_show_copy_telegram_id_tooltip } from "../../stores";
  import { _ } from "svelte-i18n";
  import { api, getComment, scrollToElement } from "../../../helpers";
  import { tick } from "svelte";
  import { getComments } from './services';
  import { currentReplyCommentId } from './components/ReplyInput/store';

  import Pagination from "../Pagination.svelte";
  import Tooltip from "../Tooltip.svelte";
  import NewComment from '../Comments/components/NewComment/NewComment.svelte';
  import CommentGetChildAction from "./components/CommentGetChildAction/CommentGetChildAction.svelte";
  import Comment from './components/Comment/Comment.svelte';
  import Alert from "../Alert.svelte";
  import SortPanel from "./components/SortPanel/SortPanel.svelte";
  import { addToast } from '../Toasts/store';
  import ReportModal from './components/Comment/components/ReportModal.svelte';
  
  export let id_publicate;
  export let disable_comments;

  let comments = [];
  let fixedComments = [];
  let allComments = [];
  let pagination = null;
  let isShowReportModal = false;

  let currentPage = 1; 
  let reportedComment = null;
  let sortItem = 'created_at';
  let inputRef;
  let scrollbox;

  $: initializationComments(id_publicate, $querystring);

  const getFixedComments = async (publicationId) => {
    const response = await api(`/api/v1/fixed-comment/list/${publicationId}/`);
    const data = await response.json();
    return data.map((item) => ({ ...item, isFixed: true }));
  }

  const initializationComments = async (publicationId, query) => {
    const params = new URLSearchParams(query);
    const commentTargetId = params.get('comment_target_id');
    const ordering = params.get('ordering');

    let commentId;
    let childCommentId;

    if (ordering) {
      sortItem = ordering;
    } else if (localStorage.hasOwnProperty('sortComments')) {
      sortItem = localStorage.getItem('sortComments');
    }

    if (commentTargetId) {
      const comment = await getComment(commentTargetId, sortItem);

      currentPage = comment.comment_parent_page;
      childCommentId = comment.comment_pk;
      commentId = comment.comment_parent_pk;

      localStorage.setItem('sortComments', 'created_at');
    }

    fixedComments = await getFixedComments(publicationId);
    [pagination, comments] = await getComments(publicationId, currentPage, sortItem);

    allComments = [...fixedComments, ...comments];

    if (+childCommentId) {
      const parentComment = allComments.find((c) => +c.pk === +commentId);

      if (parentComment) {
        await addChildrenCommentsToParentComment(parentComment);
      }
    }

    await tick();

    if (childCommentId || commentId) {
      setTimeout(() => {
        scrollToElement(+childCommentId || +commentId);
      }, 50);
    }

    if ($push_button_message && allComments.length) {
      setTimeout(() => {
        scrollToElement(allComments[0].pk, false);
        push_button_message.set(false);
      }, 100);
    };
  }

  const addChildrenCommentsToParentComment = async (parentComment, isNeedScroll) => {
    const childrens = await getChildrenComments(parentComment.pk);

    parentComment.childrens = childrens;
    parentComment.childrens_count = childrens.length;

    allComments = allComments;

    if (isNeedScroll) {
      await tick();

      scrollToElement(childrens[childrens.length - 1].pk);
    }
  }

  const getChildrenComments = async (parentId) => {
    const response = await api(`/api/v1/children-comment/list/${parentId}/`);
    const childrens = await response.json();

    return childrens;
  };

  const changePagination = async (e) => {
    currentPage = e.detail.page;

    [pagination, comments] = await getComments(id_publicate, currentPage, sortItem);

    if (currentPage === 1) {
      fixedComments = await getFixedComments(id_publicate);
      allComments = [...fixedComments, ...comments];
    } else {
      fixedComments = []
      allComments = [...comments];
    }
  };

  const scrollToFirstComment = () => {
    scrollToElement(allComments[0].pk, false);
  }

  const scrollToBottomPage = async () => {
    document.querySelector('.pagination').scrollIntoView(true);

    await tick();

    setTimeout(() => {
      document.querySelector('.general-layout').scrollBy(0, 150); 
    }, 50);
  }

  const changeInputComment = async (event) => {
    if (!event.detail.data.parent) {
      const isSortByCreatedAt = sortItem === '-created_at';
      const page = isSortByCreatedAt ? 1 : pagination.count_pages;
      
      await changePagination({ detail: { page } });

      if (!isSortByCreatedAt) {
        scrollToBottomPage();
      } else {
        scrollToFirstComment();
      }
    }

    if (event.detail.data.parent) {  
      const parentComment = allComments.find((c) => c.pk === event.detail.data.parent);

      addChildrenCommentsToParentComment(parentComment, true);
    }

    currentReplyCommentId.set(null);
  }

  const scrollToChildren = (event) => {
    const comment = event.detail.comment;

    if (comment.comment_to_comment_delete) {
      addToast($_('commentNoLongerExist'));
      return;
    }

    scrollToElement(comment.answer_to_comment);
  }

  const reportComment = async event => {
    if (!event.detail.report) {
      isShowReportModal = false
      return
    } 

    const path = `api/v1/report-comment/create/${reportedComment.pk}/`
    const method = 'POST'
    const body = '{}'
    const isJSON = true

    await api(path, method, body, isJSON)
  }

  const openReportModal = comment => {
    isShowReportModal = true
    reportedComment = comment
  }

  const fixedComment = async (comment) => {
    try {
      const response = await fetch(
        `/api/v1/comment/is-fixed-update/${comment.pk}/`, {
          method: 'PATCH',
          headers: { 
            'Content-Type': "application/json", 
            'Authorization': `Secret ${$access_token}`,
          },
          body: JSON.stringify({ is_fixed: !comment.isFixed }),
        }
      );

      if (!response.ok) {
        const { non_field_errors } = await response.json();
        addToast(non_field_errors[0]);
        return;
      }

      comment.isFixed = !comment.isFixed;
      currentPage = 1;
      initializationComments(id_publicate, $querystring);
    } catch (error) {
      console.error(error);
    }
  }
</script>

{#if allComments.length && allComments.length >= 2}
  <SortPanel 
    {sortItem} 
    comments={allComments} 
    on:change-sort={async (e) => {
      sortItem = e.detail.sort;
      currentPage = 1;
      [pagination, comments] = await getComments(id_publicate, currentPage, sortItem)

      allComments = [...fixedComments, ...comments];
    }} 
  />
{/if}

{#if disable_comments}
  <Alert text={$_("alertDanger")} color="#5A5F6D99" />
{/if}

<div class="main comments">
  {#each allComments as comment, idx}
    <div 
      class="comment" 
      id={comment.pk}
      style:border-bottom={comment.isFixed ? '1.5px solid #2B50ED' : ''}
    >
      <Comment
        {comment}
        {id_publicate}
        {sortItem}
        {disable_comments}
        isLastComment={idx == (allComments.length - 1)}    
        on:created-comment={changeInputComment}
        on:report={() => openReportModal(comment)}
        on:fixed-comment={() => fixedComment(comment)}
        on:update={(event) => {
          if (event.detail.data && !comment.isFixed) {
            const tempChildrens = [...comment.childrens];
            
            comment = event.detail.data;
            comment.childrens = tempChildrens;
          } else {
            allComments.splice(idx, 1);
          }
          
          allComments = allComments;
        }}
      />

      {#if comment.childrens_count && !comment.childrens?.length}
        <CommentGetChildAction
          {comment}
          on:get-children={addChildrenCommentsToParentComment(comment)}
        />
      {/if}
      
      {#if comment.childrens?.length}
        {#each comment.childrens as child, index}
          <div class="comment child" id={child.pk}>
            <Comment
              isChild
              {index}
              comment={child}
              {sortItem}
              {id_publicate}
              {disable_comments}
              isLastComment={index === (comment.childrens.length - 1)}    
              on:created-comment={changeInputComment}
              on:report={() => openReportModal(child)}
              on:update={() => {
                const childComment = comment.childrens[index];

                comment.childrens.forEach((c) => {
                  if (c.answer_to_comment === childComment.pk) {
                    c.comment_to_comment_delete = true;
                  }
                });

                comment.childrens_count -= 1;
                comment.childrens.splice(index, 1);

                if (comment.abstract_removed && !comment.childrens_count) {
                  allComments.splice(idx, 1);
                }

                allComments = allComments;
              }}
              on:scroll-to-children={scrollToChildren}
            />
          </div>
        {/each}
      {/if}
    </div>
  {/each}

  {#if !disable_comments}
    <div class="comments-footer">
      <div bind:this={scrollbox}>
        <NewComment
          bind:inputRef
          on:update={changeInputComment}
          {id_publicate}
        />
      </div>
    </div>
  {/if}
</div>

{#if $is_show_copy_comment_tooltip}
  <Tooltip text={$_("copyTooltipText")} />
{/if}

{#if $is_show_copy_telegram_id_tooltip}
  <Tooltip text={$_("copyTelegramIdTooltipText")} />
{/if}

{#if pagination}
  <div class="pagination">
    <Pagination 
      {currentPage} 
      {pagination} 
      on:change-page={(e) => { 
        changePagination(e);
        scrollToFirstComment(); 
      }} 
    />
  </div>
{/if}

{#if isShowReportModal}
  <ReportModal on:report={reportComment} />
{/if}

<style lang="scss">
  .comment {
    border-top: 1px solid #E0E8F6;

    &.child {
      border-top: none;
    }
  }

  .pagination {
    display: flex;
    justify-content: end;
    margin-top: 20px;
  }

  .comments-footer {
    position: fixed;
    bottom: 0;
    min-height: 110px;
    background: white;
    width: 100%;
    left: 0;
    z-index: 9999;
    box-shadow: 0px 1px 12px rgb(48 51 61 / 18%);
  }

  .comments-footer > div {
    width: 730px;
    margin: 0 auto;
    padding-left: 110px;

    @media (min-width: 320px) and (max-width: 1000px) {
      padding: 0 24px;
      width: auto;
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;
  }
</style>
